type ContactIconButtonProps = {
  onClick: () => void;
};

export function ContactIconButton({ onClick }: ContactIconButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex h-9 w-9 items-center justify-center text-forest-700"
      aria-label="联系管家"
    >
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden>
        <path
          d="M3 4h14v10H7l-4 3.5V4z"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinejoin="round"
        />
        <circle cx="7" cy="9" r="1" fill="currentColor" />
        <circle cx="10" cy="9" r="1" fill="currentColor" />
        <circle cx="13" cy="9" r="1" fill="currentColor" />
      </svg>
    </button>
  );
}
